// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"304":"dd585a4e","306":"372f930e","510":"60ef49f7","559":"fb5f357f","806":"f569cda6"}[chunkId] + ".css";
};